import { percentageFormatter, priceFormatter } from '@2wunder/klarx-tool'
import * as React from 'react'

import Unit from './Unit'

const Pricing: React.FC<MemberProps<IProductRequestItem>> = ({ member }) => {
  if (member.response !== 'confirmed') return <></>

  return (
    <>
      {member.cost_percentage ? (
        <h6 className={'text-black mb-0'}>{percentageFormatter(member.cost_percentage)}</h6>
      ) : (
        <h6 className={'text-black mb-0'}>
          {priceFormatter(member.net_price)} / <Unit value={member.price_unit} />
        </h6>
      )}
    </>
  )
}

export default Pricing
